module.exports = __webpack_public_path__ + "img/m4.9849e39e.jpg";